import HeroSection from "@/components/Future Mentor/HeroSection";
import Footer from "@/components/Index/Footer";
import Navbar from "@/components/Index/Navbar";

export default function FutureMentor() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <Footer />
    </>
  );
}
